import React, { useState, useEffect } from "react";
import LeagueCard from "components/leagueCard";
import SkeletonLoader from "components/skeletonLoader";
import { useUser } from "reactfire";
import { query, doc, getDoc } from "firebase/firestore";
import { useFirestore } from "reactfire";
import { useFunctions } from "reactfire";
import { httpsCallable } from "firebase/functions";
const LeagueMessage = ({ message }) => {
  const firestore = useFirestore();
  const functions = useFunctions();

  const [league, setLeague] = useState(undefined);
  const [isLoading, setIsLoading] = useState(false);
  const { data: user } = useUser();

  const deleteMessage = httpsCallable(functions, "deleteMessage", {
    timeout: 530000,
  });

  const callDeclineLeague = async () => {
    let data = {
      userId: user.uid,
      messageId: message.id,
    };

    try {
      await deleteMessage(data);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (!message) {
      return;
    }
    const fetchLeague = async () => {
      setIsLoading(true);
      let leagueQuery = query(
        doc(firestore, "userTournaments", message?.leagueId)
      );
      const leagueSnapshot = await getDoc(leagueQuery);
      if (!leagueSnapshot.exists()) {
        setIsLoading(false);
        return;
      }

      const leagueData = {
        id: leagueSnapshot.id,
        ...leagueSnapshot.data(),
      };
      setLeague(leagueData);
      setIsLoading(false);
    };

    fetchLeague();
  }, [message]);

  useEffect(() => {
    if (!league) {
      return;
    }

    const alreadyJoined = league?.users.some((id) => id === user.uid);
    const deadlinePassed =
      new Date(league?.deadline?.seconds * 1000) < new Date() &&
      league?.gameType == 1;

    if (alreadyJoined || deadlinePassed || !league?.visible) {
      callDeclineLeague();
    }
  }, [league]);

  return isLoading || !league ? (
    <SkeletonLoader type={"tournamentCard"} amount={1} variant={"small"} />
  ) : (
    <>
      <div className="flex text-xs pb-2">
        {message?.fromUser?.name} invited you to:
      </div>
      <LeagueCard leagueData={league} invited={true} messageId={message?.id} />
    </>
  );
};

export default React.memo(LeagueMessage);
